<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-col>
        <v-row justify="center" align="center">
          <div class="presentation-layout" v-if="last">
            <div class="presentation">
              <v-container>
                <v-col>
                  <v-row justify="center" align="center" class="mb-2">
                    <!-- <v-icon class="weather-icon">
                         {{ units.prediction_value2icon(icon_id) }}
                         </v-icon> -->
                    <span>
                      <img class="weather-icon"
                           :src="units.prediction_value2iconurl(icon_id)"
                      />
                    </span>
                    <span class="text-h1">
                      {{ units.round(last.temp, 1) }} °C
                    </span>
                  </v-row>

                  <v-row justify="center" align="center" class="mb-2">
                    <span class="text-h5">
                      Sensació tèrmica de {{ units.round(last.heat_index, 1) }} °C
                    </span>
                  </v-row>

                  <v-row justify="center" align="center">
                    <v-icon color="blue">
                      mdi-thermometer-low
                    </v-icon>
                    <span class="text-h5">
                      {{ units.round(last.temp__min, 1) }} °C
                      a les
                      {{ units.hhmm(last.temp__min__datetime) }} h
                    </span>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-icon color="red">
                      mdi-thermometer-high
                    </v-icon>
                    <span class="text-h5">
                      {{ units.round(last.temp__max, 1) }} °C
                      a les
                      {{ units.hhmm(last.temp__max__datetime) }} h
                    </span>
                  </v-row>

                  <v-row v-if="width < 600">
                    <UpdatedClock
                      align="center"
                    />
                  </v-row>

                </v-col>
              </v-container>
            </div>

            <div class="infoboxes">
              <v-container class="pa-0">
                <v-col>
                  <v-row justify="center" align="center" class="pa-0 infoboxes-innercont">

                    <InfoBox
                      class="ma-2"
                      icon="mdi-weather-windy"
                      title="Vent"
                      :text="units.ms2kmh(last.wind_speed) + ' km/h - ' + units.round(last.wind_chill) + '°C'"
                    />

                    <InfoBox
                      class="ma-2"
                      icon="mdi-weather-windy"
                      title="Mitjana del vent"
                      :text="units.ms2kmh(last.wind_speed__avg) + ' km/h - ' + units.deg2wind(last.wind_dir__avg) + ' ' + units.deg2arrow(last.wind_dir__avg)"
                    />

                    <InfoBox
                      class="ma-2"
                      icon="mdi-weather-sunny"
                      title="Radiació solar"
                      :text="last.solar_rad + ' W/m2'"
                    />

                    <!-- </v-row>
                         <v-row justify="center" align="center">
                    -->

                    <InfoBox
                      class="ma-2"
                      icon="mdi-water-percent"
                      title="Humitat"
                      :text="units.round(last.hum) + ' %'"
                    />

                    <InfoBox
                      class="ma-2"
                      :icon="lunar_fase_icon"
                      title="Fase lunar"
                      :text="lunar_fase_text"
                    />

                    <InfoBox
                      class="ma-2"
                      icon="mdi-weather-pouring"
                      title="Intensitat de pluja"
                      :text="units.round(last.rain_rate) + ' total/h'"
                    />

                    <!-- </v-row>
                         <v-row justify="center" align="center">
                    -->

                    <InfoBox
                      class="ma-2"
                      icon="mdi-gauge"
                      title="Baròmetre"
                      :text="units.round(last.bar_absolute, 1) + ' hPa'"
                    />

                    <InfoBox
                      class="ma-2"
                      icon="mdi-sun-wireless"
                      title="Índex de radiació UV"
                      :text="units.round(last.uv_index, 2)"
                    />

                    <InfoBox
                      class="ma-2"
                      icon="mdi-water-opacity"
                      title="Punt de rosada"
                      :text="units.round(last.dew_point, 2) + ' °C'"
                    />

                  </v-row>
                </v-col>
              </v-container>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-container>

    <!-- Prediction -->
    <div class="prediction-cont" v-if="prediction">
      <v-container class="pa-0">
        <v-col>
          <v-row>
            <span class="text-h5">
              Predicció pels pròxims dies
            </span>
          </v-row>
        </v-col>
        <v-col>
          <v-row justify="center" align="center" class="pa-0 mt-1">
            <PredictionBox
              v-for="entry in prediction.days.dies"
              v-bind:key="entry.data"
              class="ma-2"
              :title="units.prediction_date2locale_date(entry.data)"
              :icon="units.prediction_value2icon(entry.variables.estatCel.valor)"
              :temp_min="entry.variables.tmin.valor"
              :temp_max="entry.variables.tmax.valor"
              :rain="entry.variables.precipitacio.valor"
            />
          </v-row>
        </v-col>
        <v-col>
          <v-row justify="end" class="caption">
            <a href="https://www.meteo.cat/">
              © Meteocat
            </a>
          </v-row>
        </v-col>
      </v-container>
    </div>
  </div>
</template>

<script>
 import InfoBox from '@/components/InfoBox';
 import PredictionBox from '@/components/PredictionBox';
 import UpdatedClock from '@/components/UpdatedClock';
 import utils from '@/utils';
 import units from '@/units';
 import { mapState, mapActions } from 'vuex';

 export default {
   name: 'Temps',

   components: {
     InfoBox,
     PredictionBox,
     UpdatedClock,
   },

   data: () => ({
     units: units,
   }),

   created() {
     if (! this.last)
       this.LOAD_LAST();
   },

   computed: {
     ...mapState([
       'last',
       'prediction'
     ]),

     width() {
       return document.body.clientWidth;
     },

     icon_id() {
       if (!this.prediction || !this.prediction.hours)
         return -1;
       let now = new Date();
       let sorted = this.prediction.hours.dies[0].variables.estatCel.valors.map(
         function(entry) {
           let dt = new Date(entry.data.replace('Z',''));
           return {
             valor: entry.valor,
             data: dt,
             dist: Math.abs(dt - now),
           }
         }
       ).sort((a, b) => (a.dist - b.dist))
       return sorted[0].valor;
     },

     lunar_fase() {
       return utils.getMoonPhase(new Date());
     },

     lunar_fase_icon() {
       return units.lunar_fase2icon(this.lunar_fase);
     },

     lunar_fase_text() {
       return units.lunar_fase2text(this.lunar_fase)
     },
   },

   methods: {
     ...mapActions(['LOAD_LAST'])
   }
 };
</script>

<style>
 .presentation-layout {
   display: flex;
   flex-wrap: wrap;
   width: 100%;
 }

 .presentation {
   flex-grow: 3;
   width: 35vw;
 }

 .infoboxes {
   flex-grow: 2;
   margin-right: 2em;
   margin-left: 2em;
   width: 60vw;
 }

 @media screen and (max-width: 1000px) {
   .presentation {
     width: auto;
   }
   .infoboxes {
     width: auto;
   }
 }

 .weather-icon {
   width: 1em;
   height: 1em;
   margin-bottom: -.3em;
   font-size: 10em !important;
 }

 .prediction-cont {
   margin-top: 2em;
 }
</style>
